import React, { useEffect, useState } from 'react';
import HelpIcon from '@mui/icons-material/Help';

import { useTheme } from 'contexts/ThemeContext';
import { useUser } from 'contexts/UserContext';

import { ACTIVATION } from 'utils/rest';

import { ButtonCreate } from 'components/ButtonCreate';
import { Text, Tooltip } from 'components/DataDisplay';
import { Container, Item, Row } from 'components/Layout';
import { Loading } from 'components/Loading';
import { TableData } from 'components/TableData';

const MediaCategoriesContainer = () => {
  const { isSuperAdmin } = useUser();
  const { themeColors } = useTheme();
  const [rows, setRows] = useState([]);
  // TODO ajouter search
  // const [allRows, setAllRows] = useState([]);

  const [loaded, setLoaded] = useState(false);
  const [inProgress, setinProgress] = useState(false);

  const startImportDeals = async () => {
    setinProgress(true);

    await ACTIVATION.importActivationCategories();
    setinProgress(false);
    setLoaded(false);
  };

  const tooltipContent = items => {
    return (
      <Container style={{ width: '300px' }}>
        {Object.entries(items).map(([format, deals]) => (
          <Row spacing={0}>
            <Item xs={3}>
              <Text color={themeColors.dark}>{format}</Text>
            </Item>
            <Item xs>
              <Text color={themeColors.dark}>{deals.join(' / ')}</Text>
            </Item>
          </Row>
        ))}
      </Container>
    );
  };

  const formatROS = ROS => {
    return (
      <Item flex>
        <Text>{ROS ? 'TRUE' : 'FALSE'}</Text>
      </Item>
    );
  };

  const formatDeals = (deals = {}) => {
    const keys = Object.keys(deals);
    if (keys.length === 0) {
      return 'Aucun';
    }

    return (
      <Container>
        <Row spacing={2}>
          <Item flex>
            <Tooltip isIcon title={tooltipContent(deals)}>
              <HelpIcon />
            </Tooltip>
          </Item>
        </Row>
      </Container>
    );
  };

  const getDatas = async () => {
    const [activationCategories, allActivableMedia] = await Promise.all([
      ACTIVATION.getActivationCategories(),
      ACTIVATION.getActivableMedias(false)
    ]);

    const mapped = activationCategories.map(activationCategorie => {
      const { media } = activationCategorie;

      const { name: mediaName } = allActivableMedia.find(
        el => el.key === media
      ) || { name: media };

      return {
        ...activationCategorie,
        mediaName
      };
    });

    // setAllRows(mapped);
    setRows(mapped);

    setLoaded(true);
  };

  useEffect(() => {
    if (!loaded) {
      getDatas();
    }
    // eslint-disable-next-line
  }, [loaded]);

  return (
    <Container spacing={5} style={{ padding: '20px' }}>
      <Loading loading={!loaded}>
        <Row>
          <Item xs justify="flex-end">
            <ButtonCreate
              disabled={!isSuperAdmin}
              onClick={startImportDeals}
              loading={inProgress}
            >
              Reimporter
            </ButtonCreate>
          </Item>
        </Row>
        <Row>
          <Item>
            <TableData
              headers={[
                {
                  label: 'Média',
                  id: 'mediaName',
                  sortKey: 'mediaName'
                },
                { label: 'Name', id: 'name', sortKey: 'mediaName' },
                { label: 'Reach', id: 'reach', sortKey: 'reach' },
                {
                  label: 'ROS',
                  id: 'ROS',
                  format: ROS => formatROS(ROS)
                },
                {
                  label: 'Deals',
                  id: 'deals',
                  sortKey: 'deals',
                  format: deals => formatDeals(deals)
                }
              ]}
              hidenFields={['_id']}
              rows={rows}
            />
          </Item>
        </Row>
      </Loading>
    </Container>
  );
};

export default MediaCategoriesContainer;
